var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"square__shrink--container"},[_c('div',{staticStyle:{"margin-bottom":"10px"}},[_c('p',{staticClass:"f-ui-1-bold"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_c('div',{ref:"shrink__container",staticClass:"square__shrink-content--container",style:({ height: `${_vm.containerSize}px` })},_vm._l((_vm.shownItems),function(square,idx){return _c('div',{key:square.scenario,staticClass:"squares",class:[
        `square-${idx}`,
        `background-${square.color}`,
        `corner-${_vm.pos}`,
      ],style:({
        width: `${(_vm.containerSize * square.value) / _vm.max}px`,
        height: `${(_vm.containerSize * square.value) / _vm.max}px`,
      })},[_c('div',[_c('p',{staticClass:"f-ui-2-bold",class:[
            'square__shrink--label',
            `text__pos--${_vm.pos}`,
            { hide: square.value <= 0.05 },
            { 'text__pos--offset': square.offset },
          ],style:({
            left: `${
              square.offset ? (_vm.containerSize * square.value) / _vm.max : ''
            }px`,
            top: `${square.offset ? '-20px' : ''}`,
          })},[_vm._v(" "+_vm._s(square.value.toFixed(2))+" ")])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }